<template>
	<modal name="search-modal" class="search-modal" transition="scale" @closed="$store.dispatch('hideIsSearching')" @opened="focusInput()">
		<div class="search-modal-content">
			<div class="container">
				<div class="search-bar">
					<input type="text" ref="search" placeholder="Busca por evento, ciudad, artista, equipo, competición" v-model="search" v-debounce:300ms="getEventos">
					<input type="text" ref="search" placeholder="Buscar eventos" v-model="search" v-debounce:300ms="getEventos" class="inputMobile">
					<div class="search-modal-close" @click="$modal.hide('search-modal')">
						<i class='bx bx-x'></i>
					</div>
				</div>
				<div class="search-main">
					<div class="search-categories" v-if="!isCargandoCategorias">
						<div class="category" :class="categoriaActiva === 0 ? 'active' : ''" @click.prevent="setCategoriaActiva(0)">Todos</div>
						<div class="category" :class="Number(categoriaActiva) === Number(categoria.EventoCategoriaId) ? 'active' : ''" v-for="categoria in categorias" :key="categoria.EventoCategoriaId" @click.prevent="setCategoriaActiva(categoria.EventoCategoriaId)">
							{{ categoria.EventoCategoriaNombre }}
						</div>						
					</div>
					<div class="search-results">
						<div class="eventos-row" v-if="isCargandoEventos && eventos.length <= 0">
							<SkeletonEventoCard class="evento" v-for="eve in 4" :key="eve" :isDarkMode="true" />
						</div>
						<div class="eventos-row" v-else>
							<EventCardAux v-for="eve in eventos" :evento="eve" :key="eve.Evento.EventoId" @click="irAEvento(eve.Evento.EventoId, eve.Evento.EventoSlug)" />
						</div>
						<div class="no-results" v-if="eventos.length <= 0 && !isCargandoEventos">
							<i class='bx bx-dizzy' ></i>
							No se encontraron resultados para tu búsqueda
						</div>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
	import axios from 'axios';
	import { mapState }  from 'vuex';
	import SkeletonEventoCard from "../components/skeletons/SkeletonEventoCard.vue";
	import EventCardAux from '../components/eventos/EventCardAux.vue';

	export default {
		data(){
			return{
				search: '',
				isCargandoEventos: true,
				eventos: [],

				isCargandoCategorias: true,
				categorias: [],
				categoriaActiva: 0
			}
		},
		components: {
			EventCardAux,
			SkeletonEventoCard
		},
		computed: {
			...mapState([
				'isSearching'
			])
		},
		watch: {
			isSearching(newVal) {
				newVal ? this.$modal.show('search-modal') : this.$modal.hide('search-modal');
			}
		},
		async mounted(){
			this.getCategorias();
		},
		methods: {
			focusInput(){
				this.$refs.search.focus();
				this.search = '',
				this.categoriaActiva = 0
				this.getEventos();
			},
			irAEvento(id, slug) {
				this.$store.dispatch('hideIsSearching');
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
			async getEventos(){
				try {
					// if(this.search.trim() !== ''){
						this.isCargandoEventos = true

						let response = await axios.post('/WSEventosBuscar', {
							SearchFilter: this.search,
							EventoCategoriaId: Number(this.categoriaActiva),
							IsDesdeRedpagos: false
						});

						if(response.data.ErrorCod === 0){
							this.eventos = response.data.SDTEventos
						}
					// }
				} catch (error) {
					console.log('Ocurrió un error al cargar los eventos');
				} finally {
					this.isCargandoEventos = false
				}
			},
			async getCategorias(){
				try {
					this.isCargandoCategorias = true

					let response = await axios.post('/WSCategorias', {});

					if(response.data.ErrorCod === 0){
						this.categorias = response.data.SDTEventoCategorias
					}
				} catch (error) {
					console.log('Ocurrió un error al cargar las categorías');
				} finally {
					this.isCargandoCategorias = false
				}
			},
			async setCategoriaActiva(cat){
				this.categoriaActiva = Number(cat)
				await this.getEventos();
			}
		}
	}
</script>